/**
 * Product Sales Countdown Timer
 * Displays a countdown timer for product sales with days, hours, minutes, and seconds
 */

class ProductSalesCountdown {
  constructor(element) {
    this.element = element;
    this.endDate = element.dataset.countdownEnd;
    this.timezone = element.dataset.timezone || 'Europe/Madrid';
    this.interval = null;

    this.days = element.querySelector('[data-unit="days"]');
    this.hours = element.querySelector('[data-unit="hours"]');
    this.minutes = element.querySelector('[data-unit="minutes"]');
    this.seconds = element.querySelector('[data-unit="seconds"]');

    if (this.endDate) {
      this.init();
    }
  }

  init() {
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date();
    const end = new Date(this.endDate);
    const diff = end - now;

    if (diff <= 0) {
      this.handleExpired();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.updateDisplay(days, hours, minutes, seconds);
  }

  updateDisplay(days, hours, minutes, seconds) {
    if (this.days) this.days.textContent = String(days).padStart(2, '0');
    if (this.hours) this.hours.textContent = String(hours).padStart(2, '0');
    if (this.minutes) this.minutes.textContent = String(minutes).padStart(2, '0');
    if (this.seconds) this.seconds.textContent = String(seconds).padStart(2, '0');
  }

  handleExpired() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.updateDisplay(0, 0, 0, 0);

    // Hide the countdown or show expired message
    const countdownContainer = this.element.closest('.product-sales-countdown');
    if (countdownContainer) {
      countdownContainer.style.display = 'none';
    }
  }
}

// Initialize all countdown timers on the page
document.addEventListener('DOMContentLoaded', () => {
  const countdownElements = document.querySelectorAll('.product-sales-countdown__timer[data-countdown-end]');
  countdownElements.forEach(element => new ProductSalesCountdown(element));
});
